import React from "react";

export default function VisionAndMission() {
  return (
    <div className="bg-gray-50 p-10 rounded-lg shadow-lg mx-5 my-20">
<div className="w-full my-8 p-6 bg-white rounded-lg shadow-md">
  <h2 className="text-center text-4xl font-bold tracking-wide uppercase bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 text-transparent bg-clip-text">
    Vision and Mission
  </h2>
</div>

      <div className="flex my-20 flex-col md:flex-row gap-8">
        {/* Vision Section */}
        <div className="flex-1 bg-gradient-to-r from-blue-500 to-green-500 text-white p-6 rounded-lg shadow-md">
          <h3 className="text-2xl text-center font-bold font-edusa  mb-4">
            Vision
          </h3>
          <p className="text-lg font-poppins font-bold">
            Our vision is to be the preferred global partner for innovative
            manpower solutions, setting industry benchmarks through exceptional
            service, continuous improvement, and creating lasting value for
            businesses and communities worldwide.
          </p>
        </div>
        {/* Mission Section */}
        <div className="flex-1 bg-gradient-to-r from-purple-500 to-pink-500 text-white p-6 rounded-lg shadow-md">
          <h3 className="text-2xl text-center font-bold font-edusa  mb-4">
            Mission
          </h3>
          <p className="text-lg font-poppins font-bold">
            Our mission is to provide reliable, high-quality manpower and
            support services that drive operational excellence, ensuring client
            success through tailored solutions, skilled professionals, and a
            commitment to industry-leading service standards.
          </p>
        </div>
      </div>
    </div>
  );
}
